import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export type ComplianceFileTypeConfig = Record<
  string,
  { label: ReactNode }
>;

export const FileTypesComplianceGame: ComplianceFileTypeConfig = {
  certificates: {
    label: (
      <FormattedMessage
        id="certificates"
        defaultMessage="Certificates"
      />
    ),
  },
  approval: {
    label: (
      <FormattedMessage id="approval" defaultMessage="Approval" />
    ),
  },
  branded_report: {
    label: (
      <FormattedMessage
        id="branded_report"
        defaultMessage="Branded Report"
      />
    ),
  },
  supporting_files: {
    label: (
      <FormattedMessage
        id="supporting_files"
        defaultMessage="Supporting Files"
      />
    ),
  },
};

export const FileTypesComplianceMarket: ComplianceFileTypeConfig = {
  rng_report: {
    label: (
      <FormattedMessage id="rng_report" defaultMessage="RNG Report" />
    ),
  },
  isms_report: {
    label: (
      <FormattedMessage
        id="isms_report"
        defaultMessage="ISMS Report"
      />
    ),
  },
  rgs_platform_report: {
    label: (
      <FormattedMessage
        id="rgs_platform_report"
        defaultMessage="RGS Platform Report"
      />
    ),
  },
  branded_report: {
    label: (
      <FormattedMessage
        id="branded_report"
        defaultMessage="Branded Report"
      />
    ),
  },
};

/** All compliance file types (game + market) for display and filtering. */
export const FileTypesCompliance: ComplianceFileTypeConfig = {
  ...FileTypesComplianceGame,
  ...FileTypesComplianceMarket,
};
